module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d760eb306b9e48d2c9791790dec0b5a2.png";